<section class="cost-or-complexity section section__bg-gradient-parent">
  <div class="cost-or-complexity__gradient section__bg-gradient" aria-hidden="true"></div>

  <div class="cost-or-complexity__inner container">
    <div class="cost-or-complexity__content">
      <h2 class="cost-or-complexity__title heading-display">
        3d without the code, cost or complexity
      </h2>

      <p class="cost-or-complexity__subtitle subheading">
        No prior 3D knowledge required. EVRN gives you spatial control over your ideas, without the
        node graphs, the steep learning curve, or the technical demands of a legacy 3D engine.
      </p>

      <app-button [href]="`${environment.appUrl}/auth/register`">Start now</app-button>
    </div>
  </div>

  <div class="cost-or-complexity-video__inner">
    <app-youtube-player borderless videoUrl="https://www.youtube.com/watch?v=ites2vxbc5Y" />
  </div>
</section>
